import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoadingService } from '../../services/loading/loading.interceptor';

@Component({
  selector: 'app-loading-bar',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './loading-bar.component.html',
  styleUrl: './loading-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingBarComponent {
  protected readonly isLoading$ = inject(LoadingService).isLoading$;
}
